// @flow

import * as React from "react";
import { Link } from 'react-router';

type Props = {
  name: string,
  className?: string
};

export default class Scalar extends React.PureComponent<Props> {
  render() {
    return (
      <span className={this.props.className}>
        <Link
          className="cm-atom"
          to={`/user/graphql/documentation/type/${this.props.name}`}
        >
          {this.props.name}
        </Link>
      </span>
    );
  }
}
